import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface ReviewOfEstimatesForManagementBiasRommsProps {
  onBack: () => void;
}

export default function ReviewOfEstimatesForManagementBiasRomms({ onBack }: ReviewOfEstimatesForManagementBiasRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Review of estimates for management bias" />;
}
